// extracted by mini-css-extract-plugin
export default {"loader":"CardLoader_loader__UjSWA","rotation":"CardLoader_rotation__A0Ti0"};